export default "__VITE_ASSET__DMRALgqA__"